import Filter from '../../model/index-table/Filter';

export function getFilterColor() {
    let random = arr => {
        return arr[Math.floor(Math.random() * arr.length)];
    };

    return random([
        'orange', 'blue', 'green'
    ]);
}

export function getPropType(prop) {
    let type = prop.meta.type;
    if (type == 'CollectionFilter')
        return Filter.Type.Collection;
    else if (type == 'ScalarDate')
        return Filter.Type.ScalarDate;
    else if (type == 'Date')
        return Filter.Type.Date;
    else if (type == 'Scalar')
        return Filter.Type.Scalar;
    else if (type == 'Select' || prop.items !== undefined)
        return Filter.Type.Select;
    else
        return Filter.Type.String;
}